import { render, staticRenderFns } from "./wrestler_rosters.vue?vue&type=template&id=a26b222a&scoped=true&"
import script from "./wrestler_rosters.vue?vue&type=script&lang=js&"
export * from "./wrestler_rosters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26b222a",
  null
  
)

export default component.exports